/**
 * Лемматизация слов для веб-приложения отключена.
 * Вместо нее используются кросс-ссылки и fuzzy поиск.
 */

// Получаем текущий язык
var getCurrentLang = function() {
  return window.SEARCH_LANGUAGE ? window.SEARCH_LANGUAGE.getCurrentLang() : 'en';
};

// Функция лемматизации слова (теперь просто возвращает слово)
function lemmatizeWord(word, lang) {
  return word ? word.trim() : word;
}

// Лемматизация для русского языка
function lemmatizeRussian(word) {
  return word;
}

// Лемматизация для немецкого языка
function lemmatizeGerman(word) {
  return word;
}

// Экспортируем глобально для совместимости
window.SEARCH_LEMMATIZATION = {
  lemmatizeWord: lemmatizeWord,
  lemmatizeRussian: lemmatizeRussian,
  lemmatizeGerman: lemmatizeGerman
};
